import styled from '@emotion/styled';
import { Popover, Switch } from 'antd';
import { useTranslate } from '@tolgee/react';
import { atom, useAtom, useAtomValue } from 'jotai';
import { isQuickChat } from 'productLine';
import { ToolbarIcon } from '../ToolbarIcon';

const cacheKey = `@${import.meta.env.VITE_NAME}/messagesAutoTranslateState`;

const messagesAutoTranslateAtom = atom(
  isQuickChat ? false : localStorage.getItem(cacheKey) !== 'false',
);
const messagesAutoTranslateState = atom(
  (get) => get(messagesAutoTranslateAtom),
  (_, set, next: boolean) => {
    set(messagesAutoTranslateAtom, next);
    localStorage.setItem(cacheKey, JSON.stringify(next));
  },
);

export const useMessagesAutoTranslate = () => {
  return useAtomValue(messagesAutoTranslateState);
};

function MessagesAutoTranslate() {
  const { t } = useTranslate();

  const [autoTranslate, setAutoTranslate] = useAtom(messagesAutoTranslateState);

  const content = (
    <Content>
      <h4>{t('scene.chatWorkspace.messageEditor.translation.autoTranslate')}</h4>
      <dl>
        <dt>{t('scene.chatWorkspace.messageEditor.autoTranslate.label.conversationMessage')}</dt>
        <dd>
          <Switch size="small" checked={autoTranslate} onChange={setAutoTranslate} />
          <p>{t('scene.chatWorkspace.messageEditor.translation.autoTranslateDescription')}</p>
        </dd>
      </dl>
    </Content>
  );

  return (
    <Popover arrowPointAtCenter trigger="click" placement="topLeft" content={content}>
      <ToolbarIcon
        icon="translate"
        className={autoTranslate ? 'text-[var(--fett-app-primary-color)]' : ''}
      />
    </Popover>
  );
}

const Content = styled.div`
  color: var(--fett-text-primary);
  > dl {
    display: flex;
    margin-bottom: 0;
    > dt {
      margin-right: 8px;
      font-weight: normal;
      color: var(--fett-text-secondary);
    }
    > dd {
      font-size: 12px;
      color: var(--fett-text-tertiary);
      > p {
        margin-bottom: 0;
        margin-top: 4px;
      }
    }
  }
`;

export default MessagesAutoTranslate;
